export default "__VITE_ASSET__C7wntI6F__"